'use es6';

import http from 'hub-http/clients/noPortalApiClient';
const ACCOUNTS_API_BASE = '/accounts/v1/accounts';
export default class AccountsAPI {
  static getAccounts(includePins, includeStats) {
    return http.get(`${ACCOUNTS_API_BASE}/`, {
      timeout: 10000,
      query: {
        includePins,
        includeStats
      }
    });
  }
  static getAccountsCrossHublet(includePins, includeStats) {
    return http.get(`${ACCOUNTS_API_BASE}/cross-hublet`, {
      timeout: 10000,
      query: {
        includePins,
        includeStats
      }
    });
  }
  static setPinnedAccounts(pinnedAccounts) {
    return http.put(`${ACCOUNTS_API_BASE}/pinned`, {
      data: pinnedAccounts
    });
  }
}